<template>
  <div class="content">
    <el-tabs v-model="tabModel" type="border-card" @tab-click="handleTabClick">
      <el-tab-pane
        v-loading="loading"
        element-loading-text="data loading"
        name="tab1"
        class="tab"
      >
        <span slot="label"><i class="el-icon-date"></i> Detail Manager</span>
        <SpecTabPane
          :itemList="itemList"
          :formData="formData"
          :revisionData="revisionData"
          :otherNotesData="otherNotesData"
          :pageStatus="pageStatus"
          :selectProductType="selectType"
          v-if="itemList.length > 0"
        ></SpecTabPane>
      </el-tab-pane>
      <el-tab-pane
        :lazy="true"
        v-for="(item, index) in tabList"
        :key="index"
        v-loading="loading"
        element-loading-text="data loading"
        :name="'tab' + (index + 2)"
        class="tab"
      >
        <span slot="label"
          ><i class="el-icon-date"></i> Version {{ item.revNumber }}</span
        >
        <SpecTabPane
          :itemList="itemList"
          :formData="formData"
          :revisionData="revisionData"
          :pageStatus="pageStatus"
          :selectProductType="selectType"
          v-if="itemList.length > 0"
        ></SpecTabPane>
      </el-tab-pane>
    </el-tabs>

    <RevPopover
      :pageStatus="pageStatus"
      :versionInfo="versionInfo"
    ></RevPopover>
  </div>
</template>

<script>
import { EventBus } from "./config/eventBus";
import * as TypeConfig from "./config/allTypeConfig";
import * as StructConvertUtils from "./config/structConvertUtils";

import SpecTabPane from "./SpecTabPane.vue";
import RevPopover from "./components/RevPopover.vue";

export default {
  components: { SpecTabPane, RevPopover },
  data() {
    return {
      loading: true,
      tabModel: "tab1",
      selectType: "CSFMU-B", // 当前选中的产品类型
      pageStatus: "Add", // 页面状态 Add、Edit、Detail
      itemList: [], //根据类型获取模板拥有的模块
      baseInfoData: {},
      generalSpecificationData: {},
      analysisData: {},
      fattyAcidData: {},
      microbiologicalTestsData: {},
      otherNotesData: {},
      revisionData: [],
      defaultData: {}, // 用于记录初始对象
      formData: {}, // 用于存储所有字段的值
      loadSpecData: {}, // api 加载的数据
      isPrintVerify: false, // 是否打印 verify 信息
      tabList: [],
      versionInfo: {}, //版本信息
      recoverData: {},
      saveCustomFieldData: {}, //自定义字段数据
    };
  },
  provide() {
    return {
      getControlDataMethod: this.getControlData,
      getFormDataMethod: this.getSaveData,
      getInitRevisionDataMethod: this.getInitRevisionData,
      loadDetailDataMethod: this.loadData,
      loadRecoverDataMethod: this.loadRecoverData,
      setCustomFieldsMethod: this.setCustomFields,
      setNotesDataMethod: this.setupNotesData,
      getCurrentDataMethod: this.getCurrentData,
      getVersionInfoMethod: this.getVersionInfo
    };
  },
  mounted() {
    // this.pageStatus="Detail";
  },
  created() {
    this.pageStatus = "Add";
    let params = { ...this.$route.query };
    if (params.id) {
      this.pageStatus = "Edit";
    }
    // 默认加载数据
    this.loadData();
    // 监听类型选择事件
    EventBus.$on("productTypeChangeEvent", this.productTypeChangeEvent);
  },
  methods: {
    setCustomFields(params,fieldsObj) {
      // console.info('params:',params)
      // console.info('fieldsObj:',fieldsObj)

      this.saveCustomFieldData[params.item.attr] = fieldsObj;

    },
    handleTabClick(tab) {
      if (tab.name === "tab1") {
        let params = { ...this.$route.query };
        if (params.id) {
          this.pageStatus = "Edit";
        } else {
          this.pageStatus = "Add";
        }
        let productType = this.loadSpecData.productType;
        this.dataTransfer(this.loadSpecData, productType);
      } else {
        this.pageStatus = "Detail";
        let tidx = tab.name.substring(3, tab.name.length);
        let data = this.tabList[tidx - 2];
        let productType = data.productType;
        this.dataTransfer(data, productType);
      }
    },
    loadRecoverData() {
      let num = this.tabModel.substring(3, this.tabModel.length);
      this.tabModel = "tab1";
      this.pageStatus = "Edit";
      this.dataTransfer(
        this.recoverData[num - 2],
        this.recoverData.productType
      );
    },
    loadData() {
      if (this.pageStatus != "Add") {
        let params = {
          id: this.$route.query.id,
        };
        this.$api.handleSpec.getNewSpecDetail(params).then((data) => {
          this.loadSpecData = data;
          let productType = data.productType;
          this.dataTransfer(data, productType);
        });
        this.$api.handleSpec.getNewSpecAuditedDetail(params).then((data) => {
          this.recoverData = data;
          this.tabList = data;
        });
      } else {
        const initData = TypeConfig.typeData[0].data;
        this.dataTransfer(initData, "CSFMU-B");
      }
    },
    getControlData(item) {
      return this[item];
    },
    getCurrentData() {
      return this.loadSpecData || {};
    },
    
    // 新增：获取版本信息
    getVersionInfo() {
      return this.versionInfo;
    },
    getInitRevisionData() {
      let revisionData = {
        revisionDate: "",
        requestedBy: "",
        revisedNotes: "",
        editedBy: "",
        reason: "",
        approvedBy: "",
        isComplete: false,
      };
      return revisionData;
    },
    getSaveData() {
      console.info("this.saveCustomFieldData:", this.saveCustomFieldData);
      this.baseInfoData.list["custom_field"] =
        this.saveCustomFieldData["custom_field"];

      this.generalSpecificationData.list["custom_field_before_regular_data"] =
        this.saveCustomFieldData["custom_field_before_regular_data"];

      this.generalSpecificationData.list["custom_field"] =
        this.saveCustomFieldData["gs_custom_field"];

      //左右两侧数据
      let microbiologicalTestsData2 = this.microbiologicalTestsData;
      let mtList = this.saveCustomFieldData["left_mt_custom_field"];
      let mtRightList = this.saveCustomFieldData["right_mt_custom_field"];
      if (mtList) {
        let arr = [];
        for (let i = 0; i < mtList.length; i++) {
          let item = mtList[i];
          let rightItem = mtRightList[i];
          arr.push({
            fields: item.fields,
            specification: item.specification,
            test_method: rightItem.test_method,
          });
        }
        let len = this.microbiologicalTestsData.leftList.length;
        microbiologicalTestsData2.leftList[len - 1].value = arr;
        microbiologicalTestsData2.leftList["mt_custom_field"] = arr;
      }

      let fattyAcidData2 = this.fattyAcidData;
      let faList = this.saveCustomFieldData["left_fa_custom_field"];
      let faRightList = this.saveCustomFieldData["right_fa_custom_field"];
      if (faList) {
        let arr = [];
        for (let i = 0; i < faList.length; i++) {
          let item = faList[i];
          let rightItem = faRightList[i];
          arr.push({
            fields: item.fields,
            specification: item.specification,
            test_method: rightItem.test_method,
          });
        }
        let len = this.fattyAcidData.leftList.length;
        fattyAcidData2.leftList[len - 1].value = arr;
        fattyAcidData2.leftList["fa_custom_field"] = arr;
      }

      let analysisData2 = this.analysisData;
      let anList = this.saveCustomFieldData["left_an_custom_field"];
      let anRightList = this.saveCustomFieldData["right_an_custom_field"];
      if (anList) {
        let arr = [];
        for (let i = 0; i < anList.length; i++) {
          let item = anList[i];
          let rightItem = anRightList[i];
          arr.push({
            fields: item.fields,
            specification: item.specification,
            test_method: rightItem.test_method,
          });
        }
        //TODO:替换最custom_field
        let len = this.analysisData.leftList.length;
        analysisData2.leftList[len - 1].value = arr;
        analysisData2.leftList["an_custom_field"] = arr;
      }
      // let otherNotesData2 = this.otherNotesData;
      // console.info('otherNotesData2.list.notes.value:',otherNotesData2.list.notes.value);
      // console.info('this.saveCustomFieldData["notes"]:',this.saveCustomFieldData["notes"]);
      // otherNotesData2.list.notes.value = this.saveCustomFieldData["notes"];

      let model = {
        baseInfoData: this.baseInfoData,
        generalSpecificationData: this.generalSpecificationData,
        analysisData: analysisData2,
        fattyAcidData: fattyAcidData2,
        microbiologicalTestsData: microbiologicalTestsData2,
        otherNotesData: this.otherNotesData,
        revisionData: this.revisionData,
        revNumber: this.loadSpecData.revNumber,
        verified_time: this.loadSpecData.verifiedTime,
        rev_number: this.loadSpecData.revNumber,
      };
      console.info("model:", model);
      return model;
    },
    setDetailToDisable(obj, flag) {
      for (let key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            this.setDetailToDisable(obj[key], flag); // 递归处理子对象
          } else if (key === "disabled") {
            obj[key] = flag; // 将 disabled 设置为 true
          }
        }
      }
    },
    dataTransfer(data, productType) {
      // console.warn(productType)
      productType = productType || "CSFMU-B";
      this.selectType = productType;

      if (data.jsonValue) {
        let jsonValue = JSON.parse(data.jsonValue);
        if (jsonValue.revision) {
          this.revisionData = jsonValue.revision;
          if (this.revisionData.length > 0) {
            if (this.revisionData[this.revisionData.length - 1].isComplete) {
              this.revisionData.push(this.getInitRevisionData());
            }
          } else {
            this.revisionData.push(this.getInitRevisionData());
          }
        } else {
          this.revisionData.push(this.getInitRevisionData());
        }
      }

      // 记录版本信息
      this.setupVersionInfo(data);

      // 默认加载的模块
      this.itemList = TypeConfig.config.getFirstLayerAttribute(productType);

      let loadData = "";
      if (this.pageStatus == "Edit" || this.pageStatus == "Detail") {
        loadData = JSON.parse(data.jsonValue);
      } else {
        //添加 使用模板数据
        // loadData = TypeConfig.typeTestData[0].data;
        loadData = TypeConfig.typeData.find(
          (item) => item.type === productType
        ).data;
        console.info("loadData==:", loadData);
        this.loading = false;
      }

      //模板数据
      let templateData = TypeConfig.typeData.find(
        (item) => item.type === productType
      );
      // 如果是详情模式则所有控件设置disable为 true
      if (this.pageStatus == "Detail") {
        this.setDetailToDisable(templateData.data, true);
      } else {
        this.setDetailToDisable(templateData.data, false);
      }
      //转换数据
      const transformData = StructConvertUtils.transformMixedData(
        loadData,
        templateData.data
      );
      console.log("加载转换后的数据:", transformData);

      Object.keys(TypeConfig.DataKeys).forEach((key) => {
        const dataKey = this.toCamelCase(TypeConfig.DataKeys[key]) + "Data";
        let rowNumber =
          key === "BASE_INFO" ||
          key === "GENERAL_SPECIFICATION" ||
          key === "OTHER_NOTES"
            ? 1
            : 2;

        //处理数据
        const lowerKey = key.toLocaleLowerCase();
        let list = transformData[lowerKey];

        list = this.getFullList(list);
        if (list) {
          this[dataKey] =
            key === "BASE_INFO" ||
            key === "GENERAL_SPECIFICATION" ||
            key === "OTHER_NOTES"
              ? {
                  list,
                  type: TypeConfig.DataKeys[key],
                  row: rowNumber,
                  model: dataKey,
                }
              : {
                  ...this.getLeftRightList(list),
                  type: TypeConfig.DataKeys[key],
                  row: rowNumber,
                  model: dataKey,
                };

          // console.info("this[dataKey]:", this[dataKey]);
          //base_info、general_specification、analysis、microbiological_tests、fatty_acid、other_notes
          this.$set(this.formData, TypeConfig.DataKeys[key], {});
        }
      });
      // this.defaultData = this.formData;
      this.loading = false;
    },
    setupVersionInfo(data) {
      if (this.pageStatus == "Edit") {
        // 记录版本信息
        this.versionInfo = {
          createName: data.createName ? data.createName : "",
          createTime: data.createTime ? data.createTime.substring(0, 10) : "",
          revNumber: data.revNumber ? data.revNumber : "",
          updateName: data.updateName ? data.updateName : "",
          updateTime: data.updateTime ? data.updateTime.substring(0, 10) : "",
          verifiedName: data.verifiedName ? data.verifiedName : "",
          verifiedTime: data.verifiedTime
            ? data.verifiedTime.substring(0, 10)
            : "",
        };
      }
    },
    productTypeChangeEvent(data) {
      this.selectType = data.type;
      if (this.pageStatus == "Add") {
        let templateData = TypeConfig.typeData.find(
          (item) => item.type === this.selectType
        );
        this.dataTransfer(templateData.data, this.selectType);
      } else {
        this.dataTransfer(this.loadSpecData, this.selectType);
      }
    },
    toCamelCase(str) {
      return str.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
    },
    formatTitle(str) {
      return str
        .toLowerCase()
        .replace(/_/g, " ")
        .replace(/\b\w/g, (match) => match.toUpperCase());
    },
    mapAttributeModel(str) {
      return this[str.replace(/_([a-z])/g, (g) => g[1].toUpperCase()) + "Data"];
    },
    getFullList(data) {
      if (!data) {
        console.info("no-data:", data);
        return data;
      }
      Object.keys(data).forEach((key) => {
        const fieldKeyData = data[key];
        if (fieldKeyData.type == "custom_input") {
          // console.info("fieldKeyData.attr:", fieldKeyData.attr);
          // console.info("fieldKeyData.value:", fieldKeyData.value);
          // console.info('fieldKeyData.value == true?',fieldKeyData.value == "")
          if (fieldKeyData.value == "") {
            fieldKeyData.value = [
              {
                fields: "",
                specification: "",
                test_method: "",
                value: "",
              }
            ];
          }
        }
      });
      return data;
    },
    getLeftRightList(data) {
      if (!data) return;

      const leftList = [];
      const rightList = [];

      Object.keys(data).forEach((standardKey) => {
        const standard = data[standardKey];

        const capitalizedKey =
          standardKey.charAt(0).toUpperCase() + standardKey.slice(1);

        if (standardKey === "custom_field") {
          if (standard.value == "" || standard.value.length == 0) {
            standard.value = [
              { fields: "", specification: "", test_method: "" },
            ];
          }
        }

        if (standard.type === "custom_input") {
          const customField = this.getCustomeFireld(standard);
          leftList.push(customField);
          rightList.push(customField);
        } else {
          const commonFields = {
            label: capitalizedKey,
            tips_value: standard.tips_value,
            disabled: standard.disabled,
            fields: standard.fields,
            value: standard.value.specification,
          };
          leftList.push({ type: "input", ...commonFields });

          commonFields.value = standard.value.test_method;
          rightList.push({ type: "input", ...commonFields });
        }
      });

      return { leftList, rightList };
    },
    getCustomeFireld(standard) {
      return {
        type: "custom_input",
        label: standard.label,
        tips_value: standard.tips_value,
        disabled: standard.disabled,
        value: standard.value || "",
        fields: standard.fields || "",
        specification: standard.specification || "",
        test_method: standard.test_method || "",
        attr: standard.attr,
      };
    },
    setupNotesData(data) {
      this.saveCustomFieldData.notes = data;
    },
  },
};
</script>

<style>
@import "../style/new-spec.css";

.tab {
  min-height: 500px;
}
</style>